import React from 'react';
import styled from 'styled-components';

const Article = styled.article`
  padding-left: ${props => (props.theme.isPortrait ? 20 : 117)}px;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.secondaryColorLight};
`;

const Paragraph = styled.p`
  color: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 12px;
  line-height: 16px;
`;

export default function Footer() {
  return (
    <Article>
      <Paragraph>
        &copy;
        {` ${new Date().getFullYear()} `}
        Livewire Markets Pty Ltd. All rights reserved.
      </Paragraph>
    </Article>
  );
}
